<!-- TODO: remove debug helper once implementation is done -->
<!--<div class="row">-->
<!--    <div class="col" style="background-color: lightsalmon">-->
<!--        <strong>Functional element: {{(functionalElement$ | async)?.type}}</strong>-->
<!--    </div>-->
<!--</div>-->
@if (isStandardFunctionalElement$ | async) {
    <pace-forms-standard-functional-element
        [parentForm]="parentForm"
        [id]="id"
    ></pace-forms-standard-functional-element>
}
@if (isDropDownOptionsFunctionalElement$ | async) {
    <pace-forms-drop-down-options-functional-element
        [parentForm]="parentForm"
        [id]="id"
    ></pace-forms-drop-down-options-functional-element>
}
@if (isDiscrepancyLog$ | async) {
    <pace-forms-discrepancy-log [parentForm]="parentForm" [id]="id"></pace-forms-discrepancy-log>
}
@if (isMaterialSerialNumber$ | async) {
    <pace-forms-material-serial-number [parentForm]="parentForm" [id]="id"></pace-forms-material-serial-number>
}
@if (isDatePerformed$ | async) {
    <pace-forms-date-performed [parentForm]="parentForm" [id]="id"></pace-forms-date-performed>
}
@if (isReplacementOrLastProcedureDate$ | async) {
    <pace-forms-replacement-or-last-procedure-date
        [parentForm]="parentForm"
        [id]="id"
    ></pace-forms-replacement-or-last-procedure-date>
}
@if (isSignature$ | async) {
    <pace-forms-signature [parentForm]="parentForm" [id]="id"></pace-forms-signature>
}
@if (isValue$ | async) {
    <pace-forms-value [parentForm]="parentForm" [id]="id"></pace-forms-value>
}
@if (isAstoriaOption$ | async) {
    <pace-forms-astoria-option [parentForm]="parentForm" [id]="id"></pace-forms-astoria-option>
}
@if (isCosimaOption$ | async) {
    <pace-forms-cosima-option [parentForm]="parentForm" [id]="id"></pace-forms-cosima-option>
}
@if (isDefectiveComponentReplacement$ | async) {
    <pace-forms-defective-component-replacement
        [parentForm]="parentForm"
        [id]="id"
    ></pace-forms-defective-component-replacement>
}
